/* eslint-disable camelcase */
import chatApi from 'lib/api/chat';
import create from 'zustand';
import { IContactDiscoveryStore } from './types';

const contactDiscoveryStore = create<IContactDiscoveryStore>((set, get) => ({
  data: {},
  showSuggestionContacts: false,
  showSuggestionMembers: false,
  showSuggestionNewMembers: false,
  searchUser: async (keyword, storeKey, cursor = null, groupId = 0) => {
    set({
      data: {
        ...get().data,
        [storeKey]: {
          isLoading: true,
          members: get().data[storeKey]?.members || [],
          nextCursor: get().data[storeKey]?.nextCursor || '',
        },
      },
    });
    await chatApi.getSearchContactDiscovery(keyword, cursor, 10, groupId)
      .then((res) => {
        const { members, next_cursor } = res.data.data;
        const memberList = cursor
          ? [...get().data[storeKey].members, ...members]
          : members;

        set({
          data: {
            ...get().data,
            [storeKey]: {
              members: memberList,
              nextCursor: next_cursor,
              isLoading: false,
            },
          },
        });
      })
      .catch(() => {});
  },
}));

export default contactDiscoveryStore;
